import type { Level, RoundType } from "../puzzles/types";
import { legacyMax } from "./scoring";
import { t } from "../strings";

export interface RoundResult {
  type: RoundType;
  score: number;
  /** Most points the round could give (from 2026-09-29; older saved results have none). */
  max?: number;
  /** Distance from the pin (Pin it, Next stop). */
  km?: number;
  /** Pin it, Next stop: where the player's pin was, [lat, lng] (from 2026-10-03; drawn on the score screen). */
  at?: [number, number];
  /** Pin it: hints used (0–2; DECISIONS 2026-10-03). */
  hints?: number;
  /** "Whose steps?" guesses per revealed place: "o" right, "x" wrong, "-" skipped. */
  tries?: ("o" | "x" | "-")[];
  /** "Whose steps?": place number at which it was solved. */
  clue?: number;
}

export const TYPE_ICON: Record<RoundType, string> = { pin: "📍", next: "🧭", who: "👣" };

export const maxOfResult = (r: RoundResult): number => r.max ?? legacyMax(r.type);
export const dayTotal = (results: RoundResult[]): number => results.reduce((a, r) => a + (r?.score ?? 0), 0);
/** Place the "Whose steps?" answer was named at (1–5), 0 if not named. */
export const namedAt = (results: RoundResult[]): number => results.find((r) => r?.type === "who")?.clue ?? 0;

/**
 * What the share button sends (share text v5, DECISIONS 2026-09-29 "Transparent points"):
 * one line with the score and a nudge, then the challenge link. No emoji grid.
 * A day played in the Vault says so (share text v6): "(Classic, from the Vault)".
 */
export function shareText(dayNumber: number, level: Level, total: number, max: number, url?: string, fromVault = false): string {
  const line = fromVault ? t.share.messageVault : t.share.message;
  return [line(dayNumber, t.levels[level].label, total, max), url].filter(Boolean).join("\n");
}
